import { render } from "./TheSidebar.vue?vue&type=template&id=c2bf1c9c&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"

import "./TheSidebar.vue?vue&type=style&index=0&id=c2bf1c9c&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2bf1c9c"]])

export default __exports__